module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "h5"
    }
  }, [_vm._v("VISITING THE AREA")])]), _c('a', {
    attrs: {
      "id": "h5"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("During the preparation and research for this volume of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Battle Lines")]), _vm._v(" we based ourselves in "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Ieper (Ypres)")]), _vm._v(" for the northerly sector. Ieper boasts a good choice of hotels and bed and breakfasts and plenty of restaurants and bars particularly around the Grote Markt. There are a number of good-quality three and four-star hotels such as the "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Ariane")]), _vm._v(", "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Novotel")]), _vm._v(" and the "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Flanders Lodge")]), _vm._v(", together with some acceptable two-star establishments such as the "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Regina")]), _vm._v(" and "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Ambrosia")]), _vm._v(" hotels. Ieper abounds with bed and breakfast accommodation of which the "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Hortensia")]), _vm._v(" near the Lille Gate is consistently very good value. If you prefer camping there is a municipal campsite near the sports centre. Visitors will find our "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Battle Lines")]), _vm._v(" guidebook "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ypres")]), _vm._v(" a useful addition. Ieper is 30 minutes from Armentières and 45 minutes from the centre of Fromelles, whilst Neuve Chapelle and the Indian Memorial can often take 55 minutes driving.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "h5"
    }
  }, [_vm._v("However, we would recommend finding a base further south if you are intending to spend a few days exploring the area. "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Armentières")]), _vm._v(" has the two-star "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Hotel Joly")]), _vm._v(" on the Rue President Kennedy which is comfortable and clean, and there is quite a lot to see in the city itself. The Tourist Information Office on the Rue de Lille will provide details of walks and sites to visit such as the "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Cite Bonjean Military Cemetery")]), _vm._v(". We would also recommend the Chambre d’Hôtes "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("La Fattoria")]), _vm._v(" – ")]), _c('a', {
    attrs: {
      "href": "http://www.la-fattoria.fr",
      "target": "_blank"
    }
  }, [_vm._v("www.la-fattoria.fr")]), _vm._v(" – which is situated just off the Rue du Bois northeast of Festubert on the Rue du Pont Moreau (known as ‘Prince’s Road’ on British trench maps). The standard of both the self-catering and bed and breakfast accommodation is first class. We have personal experience of the "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Holiday Inn")]), _vm._v(" at Englos which is a short distance from the A25 on the western outskirts of Lille. Loos-en-Gohelle is a short 30-minute journey from the hotel, whilst Neuve Chapelle is only 25 minutes away. For campers "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Le Camp des Roses")]), _vm._v(" at Aubers is quite good and has the added advantage of mobile homes to rent.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61d28269","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/32_fm04.vue
// module id = 153
// module chunks = 0